import { Component } from '@angular/core';
import { SpeakerService } from './speaker.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'BNC Frontend';

  constructor(private speaker: SpeakerService) {
   }

//  changeView(mode, event) {
//    this.speaker.MODE = mode;
//  }
}



// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/app.component.ts